module.exports = __webpack_public_path__ + "static/trackingImg-4c8a7ee2f1afe9540a7cf7817c7753c9.svg";